<template>
  <div class="project-approval-page">
    <!-- 页面标题 -->
    <div class="page-header">
      <div class="header-left">
        <i class="el-icon-s-order"></i>
        <h2>建筑行业数据</h2>
      </div>
    </div>
    <!-- 筛选区域 -->
    <div class="project-title">
      <span class="project-title-list" v-for="list in pageTypeList" @click="hanlderPageType(list)"
        :class="list.value == pageType ? 'active' : ''" :key="list.value">{{ list.label }}</span>
    </div>
    <filterCom :pageType="pageType" @getTableData="getTableData" @getLoading="getLoading"></filterCom>

    <!-- 表格区域 -->
    <div class="table-section">
      <div class="table-header">
        <div class="table-title">
          <i class="el-icon-s-data"></i>
          <span>数据列表</span>
        </div>
        
      </div>
      <el-table :data="tableData" class="data-table" stripe border style="width: 100%" v-loading="loading"
        :header-cell-style="headerCellStyle">
        <el-table-column prop="indicatorName" label="指标名称" min-width="380" fixed="left" show-overflow-tooltip />
        <!-- 新增：数据提取列 -->
        <el-table-column label="数据提取" min-width="100" align="center" fixed="left">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleExtract(scope.row)">
              <i class="el-icon-data-line" style="font-size: 16px; color: #2c5282;"></i>
              <span style="color: #2c5282;">提取</span>
            </el-button>
          </template>
        </el-table-column>
        <el-table-column v-for="year in tableYears" :key="year" :prop="String(year)" :label="String(year)"
          min-width="150" align="center" show-overflow-tooltip />
      </el-table>
    </div>

    <!-- 新增：ECharts 图表展示区域 -->
    <div v-if="chartVisible" class="chart-section" ref="chartSection">
      <div class="chart-header">
        <div class="chart-title">
          <i class="el-icon-data-analysis"></i>
          <span>{{ currentRow.indicatorName }}</span>
        </div>
        <!-- 新增：累计/当期值切换 -->
        <div v-if="showDataViewToggle" class="data-view-toggle">
          <el-radio-group v-model="dataViewMode" size="small" @change="hanlderDataViewMode">
            <el-radio-button label="cumulative">累计值</el-radio-button>
            <el-radio-button label="current">{{ dataViewLabel }}</el-radio-button>
          </el-radio-group>
        </div>
        <div class="chart-controls">

          <el-radio-group v-model="chartType" size="small" @change="renderChart">
            <el-radio-button label="line">折线图</el-radio-button>
            <el-radio-button label="bar">柱状图</el-radio-button>
          </el-radio-group>
          <el-button type="text" size="small" @click="closeChart" style="margin-left: 15px;">
            <i class="el-icon-close"></i> 关闭
          </el-button>
        </div>
      </div>
      <div ref="chartContainer" class="chart-container"></div>
    </div>

  </div>
</template>

<script>
import * as echarts from 'echarts';
import filterCom from './icn/filterCom.vue';
export default {
  name: 'constructionIndustry',
  components: {
    filterCom,
  },
  computed: {
    // 新增：是否显示累计/当前数据切换选项卡
    showDataViewToggle() {
      const dataType = this.getDataType(this.tableYears);
      return dataType === 'month' || dataType === 'quarter';
    },
    // 新增：当期值标签（季度=当季值，月度=当月值）
    dataViewLabel() {
      const dataType = this.getDataType(this.tableYears);
      if (dataType === 'month') return '当月值';
      if (dataType === 'quarter') return '当季值';
      return '当期值';
    }
  },
  data() {
    return {
      pageTypeList: [{ label: '建筑业', value: 1 }, { label: '房地产', value: 2 }, { label: '固定资产投资', value: 3 }],
      pageType: 1,
      tableData: [],
      tableYears: [],
      loading: true,
      fullscreenLoading: true,
      // 新增：图表相关数据
      chartVisible: false,
      chartType: 'bar',
      currentRow: {},
      chartInstance: null,
      dataViewMode: 'cumulative',
      // 新增：数据视图模式（cumulative=累计，current=当前）
      dataViewMode: 'cumulative',
    }
  },
  methods: {
    // 判断是否为有效数字（包含 0，排除 null/undefined/空字符串/非数字字符串）
    isValidNumber(val) {
      if (val === null || val === undefined || val === '') return false;
      const num = parseFloat(val);
      return !isNaN(num) && isFinite(num);
    },

    // 安全转换数字，无效时返回 null
    safeParseFloat(val) {
      if (!this.isValidNumber(val)) return null;
      return parseFloat(val);
    },
    // 表头样式
    headerCellStyle() {
      return {
        backgroundColor: '#2c5282',
        color: '#fff',
        fontWeight: 600,
        fontSize: '14px'
      }
    },
    hanlderPageType(list) {
      this.pageType = list.value;
    },
    getLoading(loading) {
      console.log('loading', loading);
      this.loading = loading;
    },
    getTableData(tabledata, tableYears, loading) {
      this.tableData = tabledata || [];
      this.tableYears = tableYears || [];
      this.chartVisible = false;
      // 切换数据时重置为累计模式（可选，根据业务决定）
      this.dataViewMode = 'cumulative';
    },

    // 新增：刷新表格数据（根据 dataViewMode 计算累计/当期）
    refreshTableData() {
      this.tableData = this.calcPeriodData(this.rawTableData, this.rawTableYears);
      this.tableYears = this.rawTableYears ? [...this.rawTableYears] : [];

      // 如果图表已打开，同步更新 currentRow 并重新渲染
      if (this.chartVisible && this.currentRow && this.currentRow.indicatorId !== undefined) {
        this.$nextTick(() => {
          const row = this.tableData.find(r => r.indicatorId === this.currentRow.indicatorId);
          if (row) {
            this.currentRow = row;
            this.renderChart();
          }
        });
      }
    },

    // 切换累计/当期视图
    hanlderDataViewMode(mode) {
      this.dataViewMode = mode;
      // 表格数据不变，如果图表打开则重新渲染
      if (this.chartVisible) {
        this.$nextTick(() => {
          this.renderChart();
        });
      }
    },

    // 新增：从累计值计算当期值（核心逻辑）
    // 从累计值计算当期值（核心逻辑）
    calcPeriodData(rawData, years) {
      // 累计模式：直接返回浅拷贝
      if (this.dataViewMode === 'cumulative') {
        return rawData.map(row => ({ ...row }));
      }

      const dataType = this.getDataType(years);
      // 年度数据本身就是当期值，无需计算
      if (dataType === 'year') {
        return rawData.map(row => ({ ...row }));
      }

      // 深拷贝每一行
      const result = rawData.map(row => ({ ...row }));

      // 按年份前4位分组
      const yearGroups = {};
      years.forEach(period => {
        const yearBase = period.substring(0, 4);
        if (!yearGroups[yearBase]) yearGroups[yearBase] = [];
        yearGroups[yearBase].push(period);
      });

      // 每年内按周期正序排列（Q1→Q4 或 1月→12月）
      Object.keys(yearGroups).forEach(yb => {
        const periods = yearGroups[yb];
        if (dataType === 'quarter') {
          const order = { '一': 1, '二': 2, '三': 3, '四': 4 };
          periods.sort((a, b) => {
            const ma = a.match(/第(.)季度/);
            const mb = b.match(/第(.)季度/);
            return (ma ? order[ma[1]] : 0) - (mb ? order[mb[1]] : 0);
          });
        } else if (dataType === 'month') {
          periods.sort((a, b) => {
            const ma = a.match(/(\d+)月/);
            const mb = b.match(/(\d+)月/);
            return (ma ? parseInt(ma[1]) : 0) - (mb ? parseInt(mb[1]) : 0);
          });
        }
      });

      // 对每一行计算当期值
      result.forEach(row => {
        Object.keys(yearGroups).forEach(yb => {
          const periods = yearGroups[yb];

          for (let i = 0; i < periods.length; i++) {
            const period = periods[i];
            const currVal = this.safeParseFloat(row[period]);

            // 第一期（Q1 或 1月）：当期值 = 累计值
            if (i === 0) {
              // 【优化】如果首期为有效数字（包括0），保持原值；否则标记为缺失
              row[period] = currVal !== null || 0 ? currVal : '—';
              continue;
            }

            const prevPeriod = periods[i - 1];
            const prevVal = this.safeParseFloat(row[prevPeriod]);

            // 【核心优化】两期都为有效数字时才计算差值
            if (currVal !== null && prevVal !== null) {
              const diff = currVal - prevVal;

              // 【优化】差值为 0 时显示 0，不显示"—"（0 是合法数据）
              // 如果业务上不允许负数（如投资额），可在此加保护：Math.max(0, diff)
              row[period] = parseFloat(diff.toFixed(2));
            } else {
              // 任一缺失则标记为无数据
              row[period] = '—';
            }
          }
        });
      });

      return result;
    },
    // 判断数据类型：month / quarter / year
    getDataType(years) {
      if (!years || years.length === 0) return 'year';
      const firstLabel = String(years[0]);
      if (firstLabel.includes('季度')) {
        return 'quarter';
      } else if (firstLabel.includes('月')) {
        return 'month';
      } else {
        return 'year';
      }
    },
    // 根据数据类型截取要显示的数据范围
    getSliceCount(dataType) {
      switch (dataType) {
        case 'month':
          return 24;   // 月度显示最近24个月 
        case 'quarter':
          return 12;    // 季度显示最近12个季度
        case 'year':
        default:
          return null; // 年度全部显示，不截取
      }
    },
    // 新增：点击数据提取按钮
    handleExtract(row) {
      console.log('handleExtract', row);
      this.currentRow = row;
      this.chartVisible = true;
      this.$nextTick(() => {
        this.renderChart();
        // 滚动到图表位置
        this.scrollToChart();
      });
    },
    // 新增：滚动到图表位置
    scrollToChart() {
      this.$nextTick(() => {
        const chartSection = this.$refs.chartSection;
        if (chartSection) {
          chartSection.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });
        }
      });
    },
    // 新增：渲染图表
    renderChart() {
  if (!this.$refs.chartContainer) return;

  if (this.chartInstance) {
    this.chartInstance.dispose();
  }
  this.chartInstance = echarts.init(this.$refs.chartContainer);

  const allYears = this.tableYears.map(String);
  const dataType = this.getDataType(allYears);

  // 工具函数：安全读取数值
  const getValue = (year) => {
    const val = this.currentRow[year];
    if (val === null || val === undefined || val === '' || val === '—') return null;
    const num = parseFloat(val);
    return isNaN(num) || !isFinite(num) ? null : num;
  };

  // ========== 核心：根据视图模式计算显示值 ==========
  let displayValues;

  if (this.dataViewMode === 'current' && (dataType === 'month' || dataType === 'quarter')) {
    // 当期模式：从累计值实时计算当期值，不修改表格数据
    
    // 按年份分组
    const yearGroups = {};
    allYears.forEach((period, idx) => {
      const yearBase = period.substring(0, 4);
      if (!yearGroups[yearBase]) yearGroups[yearBase] = [];
      yearGroups[yearBase].push({ period, idx, value: getValue(period) });
    });

    // 初始化显示值数组（与 allYears 索引对应）
    displayValues = new Array(allYears.length).fill(null);

    // 每年内按周期正序排序并计算差值
    Object.keys(yearGroups).forEach(yearBase => {
      const items = yearGroups[yearBase];

      // 按周期正序排序（Q1→Q4 或 1月→12月）
      items.sort((a, b) => {
        if (dataType === 'quarter') {
          const order = { '一': 1, '二': 2, '三': 3, '四': 4 };
          const ma = a.period.match(/第(.)季度/);
          const mb = b.period.match(/第(.)季度/);
          return (ma ? order[ma[1]] : 0) - (mb ? order[mb[1]] : 0);
        } else {
          const ma = a.period.match(/(\d+)月/);
          const mb = b.period.match(/(\d+)月/);
          return (ma ? parseInt(ma[1]) : 0) - (mb ? parseInt(mb[1]) : 0);
        }
      });

      // 计算当期值：首月/首季 = 累计值，后续 = 当前累计 - 上期累计
      items.forEach((item, i) => {
        if (item.value === null) {
          displayValues[item.idx] = null;
          return;
        }

        if (i === 0) {
          // 首月/首季：当期值 = 累计值
          displayValues[item.idx] = item.value;
        } else {
          const prevItem = items[i - 1];
          if (prevItem.value !== null) {
            const diff = item.value - prevItem.value;
            displayValues[item.idx] = parseFloat(diff.toFixed(2));
          } else {
            displayValues[item.idx] = null;
          }
        }
      });
    });
  } else {
    // 累计模式：直接显示原始值
    displayValues = allYears.map(year => getValue(year));
  }

  // ========== 数据截取与反转（保持原有逻辑） ==========
  let years = allYears.slice();
  let values = displayValues.slice();

  const sliceCount = this.getSliceCount(dataType);
  if (sliceCount !== null && years.length > sliceCount) {
    years = years.slice(0, sliceCount);
    values = values.slice(0, sliceCount);
  }

  // 反转：从旧到新
  years = years.reverse();
  values = values.reverse();

  // 过滤无效值（不过滤 0）
  const filteredData = years.map((year, index) => ({ year, value: values[index] }))
    .filter(item => item.value !== null && !isNaN(item.value));

  years = filteredData.map(item => item.year);
  values = filteredData.map(item => item.value);

  // ========== ECharts 配置（基本不变） ==========
  const seriesName = this.dataViewMode === 'current' && (dataType === 'month' || dataType === 'quarter')
    ? `${this.currentRow.indicatorName}（${dataType === 'month' ? '当月' : '当季'}）`
    : this.currentRow.indicatorName;

  const option = {
    tooltip: {
      trigger: 'axis',
      axisPointer: { type: 'cross' },
      formatter: function (params) {
        const p = params[0];
        return `${p.name}<br/>${p.seriesName}: ${p.value !== null ? p.value : '—'}`;
      }
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      top: '15%',
      containLabel: true
    },
    xAxis: {
      type: 'category',
      data: years,
      axisLine: { lineStyle: { color: '#4a5568' } },
      axisLabel: {
        color: '#4a5568',
        fontSize: 13,
        interval: 0,
        rotate: years.length > 6 ? 30 : 0
      }
    },
    yAxis: {
      type: 'value',
      axisLine: { lineStyle: { color: '#4a5568' } },
      axisLabel: { color: '#4a5568', fontSize: 13 },
      splitLine: { lineStyle: { color: '#e2e8f0', type: 'dashed' } }
    },
    series: [{
      name: seriesName,
      type: this.chartType,
      data: values,
      smooth: true,
      itemStyle: { color: '#2c5282' },
      lineStyle: { width: 3, color: '#2c5282' },
      areaStyle: this.chartType === 'line' ? {
        color: {
          type: 'linear',
          x: 0, y: 0, x2: 0, y2: 1,
          colorStops: [
            { offset: 0, color: 'rgba(44, 82, 130, 0.3)' },
            { offset: 1, color: 'rgba(44, 82, 130, 0.05)' }
          ]
        }
      } : undefined,
      barWidth: '50%',
      label: {
        show: true,
        position: 'top',
        color: '#2c5282',
        fontSize: 12,
        formatter: function (params) {
          return params.value !== null ? params.value : '';
        }
      }
    }]
  };

  this.chartInstance.setOption(option);
  window.addEventListener('resize', this.handleResize);
},
    // 新增：关闭图表
    closeChart() {
      this.chartVisible = false;
      // 新增：重置数据视图模式
      this.dataViewMode = 'cumulative';
      if (this.chartInstance) {
        this.chartInstance.dispose();
        this.chartInstance = null;
      }
      window.removeEventListener('resize', this.handleResize);
    },
    // 新增：窗口 resize 处理
    handleResize() {
      if (this.chartInstance) {
        this.chartInstance.resize();
      }
    }
  },
  beforeDestroy() {
    // 组件销毁时清理
    if (this.chartInstance) {
      this.chartInstance.dispose();
      this.chartInstance = null;
    }
    window.removeEventListener('resize', this.handleResize);
  }
}
</script>

<style lang="less" scoped>
// 表格样式
.data-table {
  border-radius: 6px;
  overflow: hidden;
  font-size: 16px;

  ::v-deep .el-table__header-wrapper {
    th {
      background-color: #2c5282 !important;
    }
  }

  .code-text {
    color: #4a5568;
    font-size: 16px;
    letter-spacing: 0.5px;
  }

  .status-dot {
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    margin-right: 6px;

    &.active {
      background: #48bb78;
      box-shadow: 0 0 0 2px rgba(72, 187, 120, 0.2);
    }

    &.inactive {
      background: #cbd5e0;
    }
  }

  .date-icon {
    color: #2c5282;
    margin-right: 4px;
  }

  ::v-deep .el-link {
    font-weight: 500;
  }
}

.project-approval-page {
  padding: 20px;
  background: #f5f7fa;

  // 页面头部
  .page-header {
    margin-bottom: 20px;
    padding: 0 5px;

    .header-left {
      display: flex;
      align-items: center;

      i {
        font-size: 24px;
        color: #2c5282;
        margin-right: 10px;
      }

      h2 {
        font-size: 20px;
        font-weight: 600;
        color: #1a365d;
        margin: 0;
      }
    }
  }

  // 横向时间线分类区域
  .timeline-section {
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
    margin-bottom: 20px;
    overflow: hidden;

    .timeline-container {
      display: flex;
      width: 100%;
    }

    .timeline-block {
      display: flex;
      flex-direction: column;
      border-right: 1px solid rgba(0, 0, 0, 0.08);
      min-height: 90px;

      &:last-child {
        border-right: none;
      }

      // 大分类标题
      .main-category-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px 16px;
        border-bottom: 1px solid rgba(0, 0, 0, 0.06);
        justify-content: space-around;

        .main-name {
          font-size: 14px;
          font-weight: 600;
          color: #1a365d;
        }

        .main-count {
          font-size: 12px;
          color: #4a5568;
          background: rgba(255, 255, 255, 0.7);
          padding: 2px 8px;
          border-radius: 10px;
          min-width: 24px;
          text-align: center;
        }
      }

      // 二级分类容器
      .sub-categories {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
        padding: 12px 16px;
        flex: 1;
        align-items: center;
        justify-content: space-around;

        // 二级分类胶囊
        .sub-category-pill {
          padding: 6px 14px;
          border-radius: 16px;
          font-size: 13px;
          color: #4a5568;
          background: #005aa817;
          border: 1px solid #e2e8f0;
          cursor: pointer;
          transition: all 0.25s ease;
          white-space: nowrap;
          box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);

          &:hover {
            border-color: #2c5282;
            color: #2c5282;
            transform: translateY(-1px);
            box-shadow: 0 2px 6px rgba(44, 82, 130, 0.15);
          }

          // 选中状态 - 深蓝填充
          &.active {
            background: #2c5282 !important;
            border-color: #2c5282 !important;
            color: #fff !important;
            box-shadow: 0 2px 8px rgba(44, 82, 130, 0.3);
            font-weight: 500;
          }
        }
      }
    }
  }

  // 筛选区域
  .filter-section {
    background: #fff;
    border-radius: 0 0 8px 8px;
    ;
    padding: 20px;
    margin-bottom: 20px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);

    .filter-row {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      gap: 20px;
    }

    .filter-item {
      display: flex;
      align-items: center;

      .filter-label {
        font-size: 14px;
        color: #4a5568;
        margin-right: 10px;
        font-weight: 500;
        white-space: nowrap;
      }

      &.search-item {
        flex: 1;
        max-width: 300px;
      }
    }

    .date-picker {
      width: 280px;
    }

    .location-picker {
      width: 200px;
    }

    .search-input {
      width: 100%;
    }

    .filter-actions {
      margin-left: auto;

      .el-button {
        margin-left: 10px;
      }
    }
  }

  // 表格区域
  .table-section {
    background: #fff;
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);

    .table-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 20px;

      .table-title {
        display: flex;
        align-items: center;

        i {
          font-size: 18px;
          color: #2c5282;
          margin-right: 8px;
        }

        span {
          font-size: 16px;
          font-weight: 600;
          color: #1a365d;
          margin-right: 10px;
        }

        .el-tag {
          font-weight: normal;
        }
      }
    }

    // 表格样式
    .data-table {
      border-radius: 6px;
      overflow: hidden;
      font-size: 16px;

      ::v-deep .el-table__header-wrapper {
        th {
          background-color: #2c5282 !important;
        }
      }

      .code-text {
        color: #4a5568;
        font-size: 16px;
        letter-spacing: 0.5px;
      }

      .status-dot {
        display: inline-block;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        margin-right: 6px;

        &.active {
          background: #48bb78;
          box-shadow: 0 0 0 2px rgba(72, 187, 120, 0.2);
        }

        &.inactive {
          background: #cbd5e0;
        }
      }

      .date-icon {
        color: #2c5282;
        margin-right: 4px;
      }

      ::v-deep .el-link {
        font-weight: 500;
      }
    }

    // 分页
    .pagination-wrapper {
      margin-top: 20px;
      display: flex;
      justify-content: flex-end;
    }
  }

  // 新增：图表展示区域
  .chart-section {
    background: #fff;
    border-radius: 8px;
    padding: 20px;
    margin-top: 20px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);

    .chart-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 15px;

      .chart-title {
        display: flex;
        align-items: center;

        i {
          font-size: 18px;
          color: #2c5282;
          margin-right: 8px;
        }

        span {
          font-size: 16px;
          font-weight: 600;
          color: #1a365d;
        }
      }

      .chart-controls {
        display: flex;
        align-items: center;
      }
    }

    .chart-container {
      width: 100%;
      height: 400px;
    }
  }
}

// 按钮主题色覆盖
::v-deep .el-button--primary {
  background: #2c5282;
  border-color: #2c5282;

  &:hover,
  &:focus {
    background: #1a365d;
    border-color: #1a365d;
  }
}

::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #2c5282;
}

::v-deep .el-link.el-link--primary {
  color: #2c5282;

  &:hover {
    color: #1a365d;
  }
}
</style>